var Data = /** @class */ (function () {
    function Data() {
    }
    Data.toData = function (cls, json) {
        var result = new cls();
        for (var propName in json) {
            var value = json[propName];
            if (value != null) {
                result[propName] = result.toProperty(propName, value);
            }
        }
        return result;
    };
    Data.prototype.toProperty = function (name, value) {
        if (value == null)
            return value;
        return value;
    };
    Data.log = function (tag, msg) {
        if (!Data.debug)
            return;
        console.log(tag, msg);
    };
    Data.toDataArray = function (cls, jarray) {
        var result = [];
        Data.log("toDataArray", jarray);
        for (var _i = 0, jarray_1 = jarray; _i < jarray_1.length; _i++) {
            var jo = jarray_1[_i];
            var data = Data.toData(cls, jo);
            if (data) {
                result.push(data);
            }
        }
        return result;
    };
    Data.prototype.getImage = function (name, width, crop) {
        return Data.getImage(this, name, width, crop);
    };
    Data.getImage = function (data, name, width, crop) {
        if (!data.images)
            return null;
        var im = data.images[name];
        if (!im)
            return null;
        var url = im.url;
        if (!url)
            return null;
        return this.getImageUrl(url, width, crop);
        /*
        var url = im.url;

        if (!url) return null;

        if (url.indexOf("googleuser") > 0 && width) {
            var suffix = "=s" + width;
            if (crop) {
                suffix += "-c";
            }
            url += suffix;
        } else if ((url.indexOf("content.aigens.com.cn") > 0  || url.indexOf("cdn.aigens.com.cn") > 0) && width) {
            var suffix = "?x-oss-process=image/resize";
            if (crop) {
                suffix += ",m_fill";
            }
            url += suffix + ",w_"+ width;
        }


        if (url.indexOf("http://") == 0 && url.indexOf("localhost") == -1) {
            url = url.replace("http:", "https:");
        }

        if(Data.imageHost){
            var replace = "lh3.googleusercontent.com";
            var i = url.indexOf(replace);
            if(i > 0){
                var path = url.substring(i + replace.length, url.length);
                url = Data.imageHost + path;
            }
        }

        return url;
        */
    };
    Data.getImageUrl = function (url, width, crop) {
        if (!url)
            return null;
        width = Math.floor(width);
        if (url.indexOf("googleuser") > 0 && width) {
            var suffix = "=s" + width;
            if (crop) {
                suffix += "-c";
            }
            url += suffix;
        }
        else if ((url.indexOf("content.aigens.com.cn") > 0 || url.indexOf("cdn.aigens.com.cn") > 0 || url.indexOf("cdn.aigens.cn") > 0) && width) {
            var suffix = "?x-oss-process=image/resize";
            if (crop) {
                suffix += ",m_fill";
            }
            url += suffix + ",w_" + width;
        }
        if (url.indexOf("http://") == 0 && url.indexOf("localhost") == -1) {
            url = url.replace("http:", "https:");
        }
        if (Data.imageHost) {
            var replace = "lh3.googleusercontent.com";
            var i = url.indexOf(replace);
            if (i > 0) {
                var path = url.substring(i + replace.length, url.length);
                url = Data.imageHost + path;
            }
        }
        return url;
    };
    Data.prototype.clone = function (type) {
        var obj2 = Object.assign(new type(), this);
        return obj2;
    };
    Data.cloneArray = function (type, array) {
        var result = [];
        for (var _i = 0, array_1 = array; _i < array_1.length; _i++) {
            var data = array_1[_i];
            result.push(data.clone(type));
        }
        return result;
    };
    Data.remove = function (array, obj) {
        var index = array.indexOf(obj, 0);
        if (index > -1) {
            array.splice(index, 1);
        }
    };
    Data.replace = function (array, obj) {
        for (var i = 0; i < array.length; i++) {
            var id = obj.id;
            if (id && id == array[i].id) {
                array[i] = obj;
                return;
            }
        }
    };
    Data.clearCache = function (obj) {
        for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
            var key = _a[_i];
            if (key && key.indexOf('_') == 0) {
                delete obj[key];
            }
        }
    };
    Data.JsonReplacer = function (key, value) {
        if (key && key.indexOf('_') == 0) {
            return undefined;
        }
        return value;
    };
    Data.debug = false;
    return Data;
}());
export { Data };
//# sourceMappingURL=data.js.map